module.exports = __webpack_public_path__ + "img/hero.5028f197.jpg";